import { combineReducers } from "redux";
import signInReducer from "../SignIn/SignIn.reducer";

const rootReducer = combineReducers({
    SignIn: signInReducer
})

export default rootReducer